var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M22 7.74l-2 1.02V16c-1.007 2.041-5.606 3-8.5 3-3.175 0-7.389-.994-8.5-3V8.204L0 6.308 12 1l11 6.231V16l1 3h-3l1-3V7.74zM4 8.835v6.873C4.958 16.988 8.217 18 11.5 18c2.894 0 6.589-.959 7.5-2.269V9.269l-7.923 4.039L4 8.835zM2.119 6.464l9.011 5.694 9.759-4.974-8.944-5.066-9.826 4.346z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassesIcon);
export default __webpack_public_path__ + "static/media/classes-icon.6adb8913be20587ebab848b20f12bc2f.svg";
export { ForwardRef as ReactComponent };